module.exports = __webpack_public_path__ + "img/bangkok.7a8750c4.png";